import { disbursementConstants, disbursementDropdownConstants, nameSpace, name_space } from "../constants/disbursement.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null,

  dropdown_loading: false,
  dropdown_success: false,
  dropdown_request: null,
  dropdown_response: null,
  dropdown_error: null
};

export const getDisbursement = (state = initialState, action) => {
  switch (action.type) {
    case disbursementConstants[`GET_${nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case disbursementConstants[`GET_${nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response && action.response,
        error: null
      };
    case disbursementConstants[`GET_${nameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };

    case disbursementDropdownConstants[`GET_${name_space}_REQUEST`]:
      return {
        ...state,
        dropdown_loading: true,
        dropdown_request: action.request
      };
    case disbursementDropdownConstants[`GET_${name_space}_SUCCESS`]:
      return {
        ...state,
        dropdown_loading: false,
        dropdown_success: true,
        dropdown_response: action.response && action.response,
        dropdown_error: null
      };
    case disbursementDropdownConstants[`GET_${name_space}_FAILURE`]:
      return {
        ...state,
        dropdown_loading: false,
        dropdown_success: false,
        dropdown_error: action.error
      };
    default:
      return state;
  }
};
